import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { DialogProvider } from "./context/DialogProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UserProvider } from "./context/UserContext";
import { PendingRequestProvider } from './context/PendingRequestContext';
import PendingCompOffRequestProvider from "./context/PendingCompOffRequestContext";
import { SavedAnnouncementsCountProvider } from "./context/SavedAnnouncementsCountContext";
import PendingOnDutyRequestProvider from "./context/PendingOnDutyRequestContext";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { history } from "./utils/history";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DialogProvider>
      <UserProvider>
        <PendingRequestProvider>
          <PendingOnDutyRequestProvider>
            <PendingCompOffRequestProvider>
              <SavedAnnouncementsCountProvider>
                <App />
                <ToastContainer />
              </SavedAnnouncementsCountProvider>
            </PendingCompOffRequestProvider>
          </PendingOnDutyRequestProvider>
        </PendingRequestProvider>
      </UserProvider>
    </DialogProvider>
  </React.StrictMode>
);


// Register the service worker
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('App is cached and ready for offline use');
    toast.success('App is ready for offline use!', {
      position: "bottom-right",
      autoClose: 3000,
    });
  },
  onUpdate: (registration) => {
    console.log('New version available! Please refresh.');
    toast.info(
      <div>
        <p className="font-semibold mb-2">New version available!</p>
        <button
          onClick={() => {
            if (registration && registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' });
              window.location.reload();
            }
          }}
          className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
        >
          Update Now
        </button>
      </div>,
      {
        position: "bottom-center",
        autoClose: false,
        closeButton: true,
      }
    );
  }
});
